jQuery(document).ready(function ($) {
  $.tabs = {
    init: function () {
      $(document).on("click", ".m-start-media__tab", function (e) {
        e.preventDefault();

        var mediatype = $(this).data("mediatype");

        $(".m-start-media__tab.active").attr('aria-expanded', false);
        $(".m-start-media__tab.active").removeClass("active");

        $(this).addClass("active");
        $(this).attr('aria-expanded', true);

        $(".js-mediatype-content").hide();
        $(".js-mediatype-content").attr('aria-hidden', true);

        $("#js-mediatype-" + mediatype).show();
        $("#js-mediatype-" + mediatype).attr('aria-hidden', false);

      });
    },
  };
});
